import { NgModule } from '@angular/core';
import { MaterialModule } from './material/material.module';
import { MinuteSecondPipe } from './minute-second.pipe';
import { OrderByPipe } from './order-by.pipe';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';

@NgModule({
  declarations: [MinuteSecondPipe, OrderByPipe, ConfirmationDialogComponent],
  imports: [MaterialModule],
  exports: [MaterialModule, MinuteSecondPipe, OrderByPipe, ConfirmationDialogComponent],
})
export class SharedModule {}
